var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon99(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-99minutos.6ca31ef5",
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.113,
    height: 66.766,
    viewBox: "0 0 66.113 66.766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    d: "M151.111,119.688a6.589,6.589,0,0,0-2.612-2.938,8.787,8.787,0,0,0-4.245-1.469,8.179,8.179,0,0,0-6.2,1.633,7.014,7.014,0,0,0-2.939,5.55,7.617,7.617,0,0,0,1.633,6.039,7.253,7.253,0,0,0,5.224,2.775,8.035,8.035,0,0,0,4.734-.98,7.446,7.446,0,0,1-1.959,3.918,4.055,4.055,0,0,1-3.591,1.143,3.421,3.421,0,0,1-1.8-.653l-3.1,3.591a8.829,8.829,0,0,0,1.8.98,9.653,9.653,0,0,0,3.1.816,9.263,9.263,0,0,0,7.019-2.122,12.752,12.752,0,0,0,2.612-3.591,24.209,24.209,0,0,0,1.469-5.714,18.509,18.509,0,0,0-1.143-8.979Zm-5.386,6.367a3.944,3.944,0,0,1-2.775.653,3,3,0,0,1-2.285-1.306,4.787,4.787,0,0,1-.653-2.612,3.419,3.419,0,0,1,1.143-2.285,2.933,2.933,0,0,1,2.612-.653,3.653,3.653,0,0,1,2.449,1.306,3.841,3.841,0,0,1,.816,2.612,4.044,4.044,0,0,1-1.306,2.286Z",
    transform: "translate(-121.728 -91.611)",
    fill: "#323634"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    d: "M176.69,119.688a6.589,6.589,0,0,0-2.612-2.938,8.787,8.787,0,0,0-4.245-1.469,8.181,8.181,0,0,0-6.2,1.633,7.014,7.014,0,0,0-2.938,5.55,7.615,7.615,0,0,0,1.633,6.039,7.252,7.252,0,0,0,5.223,2.775,8.036,8.036,0,0,0,4.734-.98,7.447,7.447,0,0,1-1.959,3.918,4.053,4.053,0,0,1-3.591,1.143,3.421,3.421,0,0,1-1.8-.653l-3.1,3.591a8.87,8.87,0,0,0,1.8.98,9.658,9.658,0,0,0,3.1.816,9.263,9.263,0,0,0,7.019-2.122,12.766,12.766,0,0,0,2.612-3.591,24.2,24.2,0,0,0,1.469-5.714c.327-3.754,0-6.693-1.143-8.979Zm-5.387,6.367a3.941,3.941,0,0,1-2.775.653,3,3,0,0,1-2.286-1.306,4.793,4.793,0,0,1-.653-2.612,3.423,3.423,0,0,1,1.143-2.285,2.932,2.932,0,0,1,2.612-.653,3.652,3.652,0,0,1,2.448,1.306,3.841,3.841,0,0,1,.817,2.612,4.046,4.046,0,0,1-1.306,2.286Z",
    transform: "translate(-129.187 -91.611)",
    fill: "#323634"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    d: "M177.3,102.142l5.061-5.061S179.1,88.756,167.345,81.9l-5.061,5.061,5.877,5.877-1.306,1.306a30.684,30.684,0,0,0-50.6,23.506,30.69,30.69,0,1,0,54.033-20.079l1.305-1.306Zm-6.367,15.018a24.079,24.079,0,1,1-24-24.323,24.244,24.244,0,0,1,24,24.323Z",
    transform: "translate(-116.251 -81.9)",
    fill: "#85c440"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon99);
export default __webpack_public_path__ + "static/media/icon99.0d1e4b83de83dc2fda0b539fc7d6f3e8.svg";
export { ForwardRef as ReactComponent };